var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "embroidery-main-view"
  }, [_c('h5', {
    staticClass: "embroidery-main-view-title text-center"
  }, [_vm._v(_vm._s(_vm.translations.embroideryMainViewStep))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.isPersonalizationInvalid,
      expression: "!!isPersonalizationInvalid"
    }]
  }, [_vm._v(_vm._s(_vm.translations.transferDesignEmbroideryDesc))]), _c('images-view', {
    attrs: {
      "itemsToPersonalize": _vm.itemsToPersonalize
    },
    on: {
      "images-loaded": _vm.imagesLoaded
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['small-8', 'large-6', 'small-centered', 'columns', {
      'large-uncentered': _vm.itemsToPersonalize > 1
    }]
  }, [_c('label', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: {
        placement: 'top-center',
        trigger: 'manual',
        show: _vm.showModerationMessage0,
        classes: 'embroidery-main-view-label-tooltip',
        content: _vm.moderationMessage,
        container: false
      },
      expression: "{\n          placement: 'top-center',\n          trigger: 'manual',\n          show: showModerationMessage0,\n          classes: 'embroidery-main-view-label-tooltip',\n          content: moderationMessage,\n          container: false\n        }"
    }],
    staticClass: "embroidery-main-view-label",
    attrs: {
      "for": "input-text-personalization-left"
    }
  }, [_vm.itemsToPersonalize > 1 ? _c('span', [_vm._v(" " + _vm._s(_vm.translations.embroideryLeftShoeLabel))]) : _c('span', [_vm._v(_vm._s(_vm.translations.embroideryBackpackLabel))])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.message0,
      expression: "message0",
      modifiers: {
        "trim": true
      }
    }],
    ref: "personlizationInputLeft",
    class: ['embroidery-main-view-input', 'uppercase', {
      'error-moderation': _vm.showModerationMessage0
    }],
    attrs: {
      "maxlength": _vm.maxLength(0),
      "type": "text",
      "data-slide-id": "0",
      "name": "personlization-input-left",
      "id": "input-text-personalization-left"
    },
    domProps: {
      "value": _vm.message0
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.message0 = $event.target.value.trim();
      }, _vm.validateInputText],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.itemsToPersonalize > 1 ? _c('div', {
    staticClass: "small-8 large-6 small-centered large-uncentered columns"
  }, [_c('label', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: {
        placement: 'top-center',
        trigger: 'manual',
        show: _vm.showModerationMessage1,
        classes: 'embroidery-main-view-label-tooltip',
        content: _vm.moderationMessage,
        container: false
      },
      expression: "{\n          placement: 'top-center',\n          trigger: 'manual',\n          show: showModerationMessage1,\n          classes: 'embroidery-main-view-label-tooltip',\n          content: moderationMessage,\n          container: false\n        }"
    }],
    staticClass: "embroidery-main-view-label",
    attrs: {
      "for": "input-text-personalization-right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.translations.embroideryRightShoeLabel) + "\n      ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.message1,
      expression: "message1",
      modifiers: {
        "trim": true
      }
    }],
    class: ['embroidery-main-view-input', 'uppercase', {
      'error-moderation': _vm.showModerationMessage1
    }],
    attrs: {
      "maxlength": _vm.maxLength(1),
      "type": "text",
      "data-slide-id": "1",
      "name": "personlization-input-right",
      "id": "input-text-personalization-right"
    },
    domProps: {
      "value": _vm.message1
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.message1 = $event.target.value.trim();
      }, _vm.validateInputText],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "embroidery-main-view-alpha-num text-center"
  }, [_vm._v(_vm._s(_vm.translations.personalizeAlphaNum))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }